import { useEffect } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { MooringMateHomeHeader, GeneralFooter } from "../../../components";
import DockingmateHero from "../../../assets/dockingmate-login.jpeg";
import DockingmateAbout from "../../../assets/dockingmate-what-we-offer.jpg";
import captain from "../../../assets/dockingmate-about-us.png";
import "./About.css";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";

export const About = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <Box>
      <MooringMateHomeHeader />
      <Box className="page-title-section top-section" style={{ backgroundImage: `url(${DockingmateHero})` }}>
        <Box className="page-title-overlay"></Box>
        <Container maxWidth="lg">
          <Box style={{ textAlign: 'center' }}>
            <h1 className="page-heading">About Us</h1>
            <p className="sub-content">From mooring frustration to seamless freedom</p>
          </Box>
        </Container>
      </Box>
      <Box className="about-section">
        <Container maxWidth="lg">
          <Grid
            container
            spacing={3}
            sx={{
              alignItems: "center",
            }}
          >
            <Grid item md={6}>
              <h2 className="title">About Us</h2>
              <div className="section-content">
                <p>We've spent over a decade at sea, commercially and for pleasure, and faced the same problem in every harbor: uncertainty. Will there be a berth? Where is it? What facilities are there? Dockingmate was built to solve exactly that.</p>
              </div>
            </Grid>
            <Grid item md={6}>
              <img className="heroImage" alt="Beautiful luxury yacht moored in a sunny marina" src={captain} loading="lazy" />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box className="offer-section">
        <Container maxWidth="lg">
          <Grid
            container
            spacing={3}
            sx={{
              alignItems: "center",
            }}
          >
            <Grid item md={6} className="desktop-section">
              <img className="heroImage" alt="" src={DockingmateAbout} loading="lazy" />
            </Grid>
            <Grid item md={6}>
              <h2 className="title">What We Offer</h2>
              <ol className="offer-list">
                <li>
                  <h3 className="offer-title">Instant clarity</h3>
                  <p>View available mooring with exact location and full amenities</p>
                </li>
                <li>
                  <h3 className="offer-title">Book with confidence</h3>
                  <p>Secure your spot and pau safely, all-in one place</p>
                </li>
                <li>
                  <h3 className="offer-title">Smart income from your mooring</h3>
                  <p>List your berth and earn without extra effort or paperwork.</p>
                </li>
                <li>
                  <h3 className="offer-title">Automated admin</h3>
                  <p>We notify the port and handle the documents. You just show up.</p>
                </li>
                <li>
                  <h3 className="offer-title">Berth swapping made easy</h3>
                  <p>Our unique swap system lets you trade your berth with other verified users. Ideal for exploring new destinations without extra costs.</p>
                </li>
              </ol>
            </Grid>
            <Grid item md={6} className="mobile-section">
              <img className="heroImage" alt="" src={DockingmateAbout} loading="lazy" />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box className="cta-section">
        <Container maxWidth="lg">
          <Box style={{ textAlign: 'center' }}>
            <h2 className="title">Ready to experience stress-free mooring?</h2>
            <p className="sub-text">Create your account and join the network today.</p>
            <Button
              onClick={() => navigate("/signup")}
              className="btn-primary"
              variant="contained"
              color="primary"
              size="large"
            >
              Sign Up for Free Access
            </Button>
          </Box>
        </Container>
      </Box>
      <GeneralFooter />
    </Box>
  );
};
